'use strict';

export class Fields
{
    constructor(json, options = {})
    {
        // console.log(json)
        this.drawInputs(json)

        // Описание опции на третьем шаге
        $('.accordion__btn').on('click', function () {
            let optionId = $(this).data('btn')
            for (let key in json) {
                for (let key2 in json[key]) {
                    if (json[key][key2].id == optionId) {
                        $('.selection__text').html(json[key][key2].description)
                    }
                }
            }
        })
    }

    drawInputs(json)
    {
        const self = this
        let opt = json
        let total = ''
        let input = ''

        for (let key in opt) {
            let thisOpt = opt[key]
            input = ''
            for (let keyOpt in thisOpt) {
                if (thisOpt[keyOpt].type === 'select') {
                    input += self.createSelect(thisOpt[keyOpt])
                }

                if (thisOpt[keyOpt].type === 'range') {
                    input += self.createRange(thisOpt[keyOpt])
                }

                if (thisOpt[keyOpt].type === 'accordion') {
                    input += self.createAccordion(thisOpt[keyOpt])
                    // total += self.createTotal(thisOpt[keyOpt])
                }

                // total += self.createTotal(thisOpt[keyOpt])

            }
            $('[data-tab="'+key+'"]').append(input)

        }
        $('.mv-img-wrap').append(self.createImg)
    }

    createImg()
    {
        let input = ''
        let img = '<div class="selection__position">'
        img += '<img class="mv-img" src="" alt="">'
        img += '</div>'

        if (input !== '') {
            img += input;
        }

        return img
    }

    // поля с выпадающим списком
    createSelect(opt, allParents = '', addClass = '')
    {
        allParents += opt.parent+','
        const self = this
        let input = ''
        if (addClass === '' && opt.parent > 0) {
            addClass = 'd-none show-'+opt.parent;
        }
        let html = '<div class="'+opt.class_row+' '+addClass+' js-parent-field" data-code="'+opt.code+'" data-allparent="'+allParents+'">'
        html += '<div class="form-group">'
        html += '<label>'+opt.name+'</label>'
        html += '<select class="js-custom-select" data-parent-id="'+opt.parent+'" data-id="'+opt.id+'" data-measure="'+opt.measurement+'" name="'+opt.code+'" data-version value>'
        html += '<option class="conf__option-default" selected value data-img-url>'+BX.message('CONF_FORM_NOT_CHOSEN')+'</option>'

        for (let key in opt.children) {
            if (opt.children[key].type === 'option') {
                html += '<option data-parent-id="'+opt.parent+'" data-option-id="'+opt.children[key].id+'" data-img-url="'+opt.children[key].img_url+'" value="'+opt.children[key].name+'" data-code="'+opt.children[key].code+'">'+opt.children[key].name+'</option>'
            }

            if (opt.children[key].children) {
                for (let keyChild in opt.children[key].children) {
                    if (opt.children[key].children[keyChild].type === 'select') {
                        let classForParent = ''
                        input += self.createSelect(opt.children[key].children[keyChild], allParents, 'd-none show-'+opt.children[key].id+' '+classForParent)
                    }
                }
            }
        }

        html += '</select>'
        html += '</div>'
        html += '</div>'

        if (input != '') {
            html += input;
        }

        return html
    }

    // поля с ползунком
    createRange(opt, addClass = '')
    {
        const self = this
        let input = ''
        let html = '<div class="'+opt.class_row+' '+addClass+'">'
        html += '<div class="form-group">'
        html += '<label>'+opt.name+'</label>'
        html += '<div class="d-flex align-items-center">'
        html += '<input class="form-control form-control--number" data-measure="'+opt.measurement+'" data-id="'+opt.id+'" id="in-'+opt.id+'_from" placeholder="'+BX.message('CONF_FORM_FROM')+'" name="'+opt.code+'_from" value="">' +
            '<span class="px-10">-</span>' +
            '<input class="form-control form-control--number" data-measure="'+opt.measurement+'" data-id="'+opt.id+'" id="in-'+opt.id+'_to" placeholder="'+BX.message('CONF_FORM_TO')+'" name="'+opt.code+'_to" value="">' +
            '</div>'
        html += '<div class="range">' +
            '<div class="initrange" data-start="'+opt.from+'" data-end="'+opt.to+'" id="range'+opt.id+'" data-range-id="'+opt.id+'"></div>' +
            '<div class="range__val"></div>' +
            '<div class="range__val range__val--max"></div>' +
            '</div>'

        html += '</div>'
        html += '</div>'

        return html
    }

    // поля с раскрывающимся списком
    createAccordion(opt, addClass = '')
    {
        const self = this

        let html = '<button class="accordion__btn" type="button" data-toggle="collapse" data-btn="'+opt.id+'" data-target="#ab-'+opt.id+'">'+opt.name+'</button>'
        html += '<div class="'+opt.class_row+' '+addClass+'" id="ab-'+opt.id+'" data-parent="#accordion">'
        html += '<div class="accordion__box">'

        for (let key in opt.children) {
            if (opt.children[key].type === 'radio') {
                html += '<label class="custom-control custom-radio custom-control--sm">'
                html += '<input data-option-id="' + opt.children[key].id + '" class="custom-control-input '+opt.children[key].class_row+'" value="'+ opt.children[key].name +'" data-parent-id="' + opt.children[key].parent + '" data-tab="' + opt.children[key].tab + '" name="ab-' + opt.children[key].parent + '" type="radio" name="'+opt.code+'" '+(opt.children[key].default === 'Y' ? 'checked' : '')+'>'
                html += '<span class="custom-control-label">' + opt.children[key].name + '</span>'
                html += '</label>'
            }

            if (opt.children[key].type === 'group') {
                html += '<div class="form-group">'
                html += '<label class="custom-radio"><b>' + opt.children[key].name + '</b></label>'
                for (let keySubchild in opt.children[key].children) {
                    html += '<label class="custom-control custom-radio custom-control--sm">'
                    html += '<input data-option-id="' + opt.children[key].children[keySubchild].id + '" class="custom-control-input group-radio-input" value="' + opt.children[key].children[keySubchild].name + '" data-group-parent-id="' + opt.children[key].parent + '" data-parent-id="' + opt.children[key].children[keySubchild].parent + '" name="ab-' + opt.children[key].children[keySubchild].parent + '" type="radio" name="' + opt.code + '" ' + (opt.children[key].children[keySubchild].default === 'Y' ? 'checked' : '') + '>'
                    html += '<span class="custom-control-label">' + opt.children[key].children[keySubchild].name + '</span>'
                    html += '</label>'
                }
                html += '</div>'
            }
        }

        html += '</div>'
        html += '</div>'

        let optionsTotal = '<div class="selection__prop">'
        optionsTotal += '<span>'+opt.name+'</span> '
        optionsTotal += '<b class="option-val" data-id="'+opt.id+'">'+BX.message('CONF_FORM_NOT_CHOSEN')+'</b>'
        optionsTotal += '</div>'

        let finishOptionsTotal = '<div class="selection__prop selection__prop--text">'
        finishOptionsTotal += '<span class="finish__option-name">'+opt.name+'</span> '
        finishOptionsTotal += '<b class="finish__option-val" data-id="'+opt.id+'">'+BX.message('CONF_FORM_NOT_CHOSEN')+'</b>'
        finishOptionsTotal += '</div>'

        $('[data-block="options-total').append(optionsTotal)
        $('[data-block="finish-options-total').append(finishOptionsTotal)

        return html
    }

    // Сводная таблица
    createTotal(opt, addClass = '')
    {
        let defaultVal = ''
        for (let key in opt.children) {
            if (opt.children[key].default === 'Y') {
                defaultVal = opt.children[key].name
            }
        }

        let total = '<tr class="conf__total-row" data-id="' + opt.id + '" data-name="' + opt.name + '" data-tab="' + opt.tab + '">'
        total += '<td class="conf__total-title">' + opt.name + '</td>'
        total += '<td class="conf__total-val">' + defaultVal + '</td>'
        total += '<td class="conf__total-measure"></td>'
        total += '</tr>'

        $(total).insertAfter(".conf-total-table-head");

        return total
    }
}